import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';

const OrderHistory = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const { data } = await api.get('/orders/my-orders');
        setOrders(data.data || []);
      } catch (error) {
        console.error('Error:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, []);

  const statusConfig = {
    pendiente: { label: 'Pendiente', icon: '⏳', color: 'bg-yellow-100 text-yellow-700' },
    aceptado: { label: 'Aceptado', icon: '✅', color: 'bg-blue-100 text-blue-700' },
    preparando: { label: 'Preparando', icon: '👨‍🍳', color: 'bg-purple-100 text-purple-700' },
    en_camino: { label: 'En camino', icon: '🚗', color: 'bg-orange-100 text-orange-700' },
    entregado: { label: 'Entregado', icon: '🎉', color: 'bg-green-100 text-green-700' },
    cancelado: { label: 'Cancelado', icon: '❌', color: 'bg-red-100 text-red-700' }
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-serif font-bold mb-2">📋 Mis pedidos</h1>
      <p className="text-gray-500 mb-8">Historial de todos tus pedidos</p>

      {loading ? (
        <div className="text-center py-12">
          <div className="inline-block w-8 h-8 border-4 border-gold border-t-transparent rounded-full animate-spin" />
        </div>
      ) : orders.length === 0 ? (
        <div className="bg-white rounded-2xl p-12 text-center shadow-sm border border-gray-100">
          <div className="text-6xl mb-4">🍞</div>
          <h2 className="text-xl font-semibold mb-2">Aún no tienes pedidos</h2>
          <p className="text-gray-500 mb-6">Explora nuestros productos y haz tu primer pedido</p>
          <Link to="/productos" className="btn-primary inline-flex">Ver productos →</Link>
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map(order => {
            const status = statusConfig[order.status] || statusConfig.pendiente;
            return (
              <Link
                key={order.id}
                to={`/pedido/${order.id}`}
                className="block bg-white rounded-2xl p-5 shadow-sm border border-gray-100 hover:shadow-md transition"
              >
                <div className="flex flex-wrap justify-between items-center gap-4 mb-3">
                  <div>
                    <div className="font-bold">#{order.order_number}</div>
                    <div className="text-xs text-gray-500">
                      {new Date(order.created_at).toLocaleString('es-VE')}
                    </div>
                  </div>
                  <span className={`px-3 py-1 rounded-full text-xs font-semibold ${status.color}`}>
                    {status.icon} {status.label}
                  </span>
                </div>
                <div className="flex justify-between items-center pt-3 border-t border-gray-100">
                  <div className="text-sm text-gray-500">
                    {(order.items || []).length} producto(s)
                  </div>
                  <div className="text-right">
                    <div className="font-bold text-gold">${Number(order.total_usd).toFixed(2)}</div>
                    <div className="text-xs text-gray-500">Bs {Number(order.total_bs).toFixed(2)}</div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default OrderHistory;
